/**
 * @generated SignedSource<<e6d70dfa7d9a3bb50dbf39631d564c53>>
 * @relayHash 2febe8176951c7d49b530f8cc1d31be0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 029d6a91069d3a7711cb68fc60a660f9c5627c7900ac4dffab839fc2a514a7ba

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraDiscardUserBoardViewConfigInput = {
  settings?: JiraBoardViewSettings | null | undefined;
  viewId: string;
};
export type JiraBoardViewSettings = {
  filterJql?: string | null | undefined;
  groupBy?: string | null | undefined;
};
export type SaveResetViewSettingsDiscardSettingsMutation$variables = {
  input: JiraDiscardUserBoardViewConfigInput;
  settingsOpen: boolean;
};
export type SaveResetViewSettingsDiscardSettingsMutation$data = {
  readonly jira_discardUserBoardViewConfig: {
    readonly boardView: {
      readonly " $fragmentSpreads": FragmentRefs<"BusinessBoard_view" | "CardOptionSettings" | "RemoveResolvedItems">;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SaveResetViewSettingsDiscardSettingsMutation = {
  response: SaveResetViewSettingsDiscardSettingsMutation$data;
  variables: SaveResetViewSettingsDiscardSettingsMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider: {
    readonly get: () => boolean;
  };
});

import isBusinessStatusMappingEnabled_provider from '@atlassian/jira-relay-provider/src/allow-status-mapping-on-business-board.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "settingsOpen"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "message"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = [
  (v7/*: any*/),
  {
    "kind": "ScalarField",
    "name": "fieldName"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "concreteType": "JiraBoardViewColumnConnection",
  "kind": "LinkedField",
  "name": "columns",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraBoardViewColumnEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            (v9/*: any*/),
            {
              "kind": "ScalarField",
              "name": "collapsed"
            },
            {
              "kind": "TypeDiscriminator",
              "abstractKey": "__isJiraBoardViewColumn"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraStatus",
                  "kind": "LinkedField",
                  "name": "statuses",
                  "plural": true,
                  "selections": [
                    (v11/*: any*/),
                    (v9/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "statusId"
                    },
                    {
                      "concreteType": "JiraStatusCategory",
                      "kind": "LinkedField",
                      "name": "statusCategory",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "statusCategoryId"
                        },
                        (v9/*: any*/)
                      ]
                    }
                  ]
                },
                (v11/*: any*/)
              ],
              "type": "JiraBoardViewStatusColumn"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraPriority",
                  "kind": "LinkedField",
                  "name": "priority",
                  "plural": false,
                  "selections": [
                    (v11/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "priorityId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "iconUrl"
                    },
                    (v9/*: any*/)
                  ]
                }
              ],
              "type": "JiraBoardViewPriorityColumn"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "accountId"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "picture"
                    },
                    (v9/*: any*/)
                  ]
                }
              ],
              "type": "JiraBoardViewAssigneeColumn"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "concreteType": "JiraOption",
                  "kind": "LinkedField",
                  "name": "category",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "value"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "optionId"
                    },
                    {
                      "concreteType": "JiraColor",
                      "kind": "LinkedField",
                      "name": "color",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "colorKey"
                        },
                        (v9/*: any*/)
                      ]
                    },
                    (v9/*: any*/)
                  ]
                }
              ],
              "type": "JiraBoardViewCategoryColumn"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "cursor"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "totalCount"
    },
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        }
      ]
    }
  ]
},
v13 = {
  "handle": "connection",
  "key": "business_board_columns",
  "kind": "LinkedHandle",
  "name": "columns"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsDiscardSettingsMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraDiscardUserBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserBoardViewConfig",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "BusinessBoard_view"
              },
              {
                "condition": "settingsOpen",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "RemoveResolvedItems"
                  },
                  {
                    "kind": "FragmentSpread",
                    "name": "CardOptionSettings"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "SaveResetViewSettingsDiscardSettingsMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraDiscardUserBoardViewConfigPayload",
        "kind": "LinkedField",
        "name": "jira_discardUserBoardViewConfig",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "concreteType": "JiraBoardView",
            "kind": "LinkedField",
            "name": "boardView",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraViewFilterConfig",
                "kind": "LinkedField",
                "name": "filterConfig",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "jql"
                  }
                ]
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByConfig",
                "plural": false,
                "selections": (v8/*: any*/)
              },
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "name": "isViewConfigModified"
              },
              {
                "kind": "ScalarField",
                "name": "canPublishViewConfig"
              },
              {
                "concreteType": "JiraViewGroupByConfig",
                "kind": "LinkedField",
                "name": "groupByOptions",
                "plural": true,
                "selections": (v8/*: any*/)
              },
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "enabledOnly",
                    "value": true
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 100
                  }
                ],
                "concreteType": "JiraBoardViewCardOptionConnection",
                "kind": "LinkedField",
                "name": "cardOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraBoardViewCardOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "concreteType": "JiraField",
                                "kind": "LinkedField",
                                "name": "field",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v9/*: any*/)
                                ]
                              }
                            ],
                            "type": "JiraBoardViewFieldCardOption"
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "cardOptions(enabledOnly:true,first:100)"
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "selectedWorkflowId"
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "canInlineEditStatusColumns"
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "condition": "settingsOpen",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "completedIssueSearchCutOffInDays"
                  },
                  {
                    "alias": "menuCardOptions",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 200
                      }
                    ],
                    "concreteType": "JiraBoardViewCardOptionConnection",
                    "kind": "LinkedField",
                    "name": "cardOptions",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraBoardViewCardOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                      (v11/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "typeKey"
                                      },
                                      (v9/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "canToggle"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "enabled"
                                  }
                                ],
                                "type": "JiraBoardViewFieldCardOption"
                              },
                              (v10/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "cardOptions(first:200)"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v9/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "029d6a91069d3a7711cb68fc60a660f9c5627c7900ac4dffab839fc2a514a7ba",
    "metadata": {},
    "name": "SaveResetViewSettingsDiscardSettingsMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcallowstatusmappingonbusinessboardrelayprovider": isBusinessStatusMappingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};
})();

(node as any).hash = "a199cc624103b938b4a566938bd720d3";

export default node;
